import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { device } from '../../theme/breakpoints'
import { IconTypeEnum } from '../../theme/icons'

export const StyledIcon = styled.div`
  display: flex;
  ${({ $isSvg, $width, $height }) => {
    if (!$isSvg && $width) {
      return `width: ${$width}`
    }
    if (!$isSvg && $height) {
      return `height: ${$height}`
    }
  }};
  svg {
    width: ${({ $width }) => ($width ? $width : '0')};
    height: ${({ $height }) => ($height ? $height : '0')};
    ${({ $svgColor }) => {
      if ($svgColor) {
        return `
          path, rect {
             fill: ${$svgColor} 
           };`
      }
    }};

    ${({ $type, theme }) => {
      switch ($type) {
        case IconTypeEnum.carrouselArrow:
          return `
            margin: 0 0 0 ${pxToRem(10)};
          `
        case IconTypeEnum.arrowDown:
          return `
            margin: 0 ${pxToRem(26.75)} 0 0 
          `

        case IconTypeEnum.logoHeader:
          return `
              height: ${theme.iconSizes.md};
              padding: ${pxToRem(4)};
              margin: 0;
              @media ${device.laptopL}{
                height: ${theme.iconSizes.lg};
              }
            `
        case IconTypeEnum.logoHeaderMobile:
        case IconTypeEnum.logoHeaderTablet:
          return `
              margin: 0;
              padding:0;
              height: ${pxToRem(41)}
            `
        case IconTypeEnum.burgerMenu:
        case IconTypeEnum.search:
        case IconTypeEnum.contact:
          return `
              margin: ${pxToRem(16)} ${pxToRem(15)};
            `

        case IconTypeEnum.logoL:
          return `
                height: ${theme.iconSizes.lg};
                padding: ${pxToRem(4)};
                @media ${device.mobileL} {
                  height: ${theme.iconSizes.md};
                }
              `
        case IconTypeEnum.footer:
          return `
                height: ${theme.iconSizes.lg};
                @media ${device.mobileL} {
                  height: ${theme.iconSizes.md};
                }
              `
        case IconTypeEnum.logoXL:
          return `
              margin: inherit;
              height: ${theme.iconSizes.logoXL};
              @media ${device.mobileL} {
                height: ${theme.iconSizes.lg};
              }
            `
        case IconTypeEnum.arrowDownNav:
          return `
              margin: ${pxToRem(8)};
              padding: 0;
              @media ${device.laptop} {
                margin: ${pxToRem(4)};
              }
            `
        default:
          return `
                margin: ${pxToRem(8)};
              `
      }
    }};
  }
`
